import { render, staticRenderFns } from "./ViewMidtermTestResult.vue?vue&type=template&id=5fa3f93d&scoped=true"
import script from "./ViewMidtermTestResult.vue?vue&type=script&lang=js"
export * from "./ViewMidtermTestResult.vue?vue&type=script&lang=js"
import style0 from "./ViewMidtermTestResult.vue?vue&type=style&index=0&id=5fa3f93d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa3f93d",
  null
  
)

export default component.exports